<div *ngIf="busy" class="spinner">
    <img src="/static/assets/spinner.gif" width="96" height="96" alt="" /> <span i18n>Processing...</span>
</div>
<p *ngIf="done" i18n>
    All done. Your account is now slated for removal.
</p>
<p *ngIf="error" class="error" i18n>
    Operation has failed.
</p>
